(() => {
  function initSection(section) {
    if (!section || section.dataset.galleryInitialized === 'true') return;
    section.dataset.galleryInitialized = 'true';
    const reveal = section.querySelectorAll('.fade-in');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      reveal.forEach((element) => observer.observe(element));
    } else reveal.forEach((element) => element.classList.add('is-visible'));

    const floating = section.querySelector('.mg-btn-floating');
    if (floating && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { floating.classList.toggle('is-visible', entry.isIntersecting); });
      });
      observer.observe(section);
    }
  }
  function init(scope = document) { scope.querySelectorAll('.marita-gallery').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
